export default __webpack_public_path__ + "static/media/react.56f688a6.png";